export const PAPER_FORMATS = {
    "10x15 cm Rossmann": {width: 10, height: 15},
    "13x18 cm": {width: 13, height: 18},
    "15x21 cm": {width: 15, height: 21},
    "20x30 cm": {width: 20, height: 30},
    A4: {width: 21, height: 29.7},
    A5: {width: 14.8, height: 21},
    A6: {width: 10.5, height: 14.8},
};